var networkInfo = {
    chainId: "0x13",
    chainName: "Songbird Canary Network",
    rpcUrls: ["https://songbird.flr.finance/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://songbird-explorer.flare.network/"],
    symbol: "SGB",
};
export default networkInfo;
